//图片补充
function imgHelp(v) {
	if(v == null || v == undefined || v == '') {
		return '../img/moren.png';
	} else {
		if(v != null && v != '' && v != undefined) {
			if(v.indexOf('http') != -1) {
				return v
			} else {
				return 'http://47.93.225.238:28080' + v
			}
		}
	}
}

//首页商品列表时间过滤器
function homeMsgTime(v) {
	if(v) {
		v = v / 1;
		var time = new Date(v);
		return time.getFullYear() + "-" +
			changeNum((time.getMonth() + 1)) + "-" +
			changeNum(time.getDate()) +
			" " + changeNum(time.getHours()) +
			":" + changeNum(time.getMinutes()) +
			":" + changeNum(time.getSeconds());
	}
}

//首页商品列表时间过滤器
function homeTime(v) {
	var time = new Date(v);
	return changeNum((time.getMonth() + 1)) + "-" +
		changeNum(time.getDate()) +
		" " + changeNum(time.getHours()) +
		":" + changeNum(time.getMinutes());
}

//商品详情时间过滤器
function commodityDetailsTime(v) {
	var time = new Date(v);
	return time.getFullYear() + "-" +
		changeNum((time.getMonth() + 1)) + "-" +
		changeNum(time.getDate()) +
		" " + changeNum(time.getHours()) +
		":" + changeNum(time.getMinutes()) +
		":" + changeNum(time.getSeconds());
}

function zero(v) {
	if(v == null || v == '' || v == 'null') {
		return '0';
	} else {
		return v;
	}
}

function commodityDetailsTime2(v) {
	var t = v;
	var d = Math.floor(t / 1000 / 60 / 60 / 24);
	var hour = Math.floor(t / 1000 / 60 / 60 % 24);
	var min = Math.floor(t / 1000 / 60 % 60);
	var sec = Math.floor(t / 1000 % 60);
	if(hour < 10) {
		hour = "0" + hour;
	}
	if(min < 10) {
		min = "0" + min;
	}
	if(sec < 10) {
		sec = "0" + sec;
	}
	if(d / 1 > 0) {
		return d + '天' + hour + "小时" + min + "分" + sec + '秒';
	}
	if(d / 1 < 1 && hour / 1 > 0) {
		return hour + "小时" + min + "分" + sec + '秒';
	}

	if(d / 1 < 1 && hour / 1 < 1 && min / 1 > 0) {
		return min + "分" + sec + '秒';
	}

	if(d / 1 < 1 && hour / 1 < 1 && min / 1 < 1) {
		return sec + '秒';
	}
}

//商品详情我的出价时间过滤器
function commodityDetailsTime3(v) {
	var time = new Date(v);
	return changeNum(time.getHours()) +
		":" + changeNum(time.getMinutes()) +
		":" + changeNum(time.getSeconds());
}

//订单详情时间过滤器
function orderTime(v) {
	var time = new Date(v);
	return time.getFullYear() + "-" +
		changeNum((time.getMonth() + 1)) + "-" +
		changeNum(time.getDate())
}

function changeNum(num) {
	if(num < 10) {
		return "0" + num;
	}
	return num;
}

//产品名称过滤
function productNameJC(v, n) {
	if(v) {
		if(v.indexOf('甲醇') == -1) {
			return true;
		} else {
			return false;
		}
	}
}

//首页轮播时间
function bannerTime(v) {
	var time = new Date(v);
	return changeNum((time.getMonth() + 1)) + "-" +
		changeNum(time.getDate()) +
		" " + changeNum(time.getHours()) +
		":" + changeNum(time.getMinutes());
}

//首页轮播商品名称
function bannerProductNameSplit(v, n) {
	if(v) {
		if(n == '1') {
			if(v.length > 6) {
				return v.slice(0, 6);
			} else {
				return v;
			}
		}

		if(n == '2') {
			if(v.length > 6) {
				return v.slice(6, v.length);
			} else {
				return '';
			}
		}
	}
}

function noticeFileType(v){
	if(v){
		var arr=v.split('.');
		return arr[arr.length-1];
	}
}

//首页工具
function appShow(v, recommendList) {
	if(recommendList == '') {
		return 'display: none;';
	} else {
		for(var i = 0; i < recommendList.length; i++) {
			if(v == recommendList[i].id) {
				return 'display: block;'
			} else {
				if(i == recommendList.length - 1) {
					return 'display: none;';
				}
			}
		}
	}
}

//首页
function headImg(v) {
	if(v != undefined && v != null && v != '') {
		if(v.indexOf('http') != -1) {
			return v
		} else {
			return plus.storage.getItem("imgUrl") + v
		}
	} else {
		return '../img/moren.png';
	}
}

export default {
	homeTime,
	commodityDetailsTime,
	commodityDetailsTime2,
	commodityDetailsTime3,
	zero,
	orderTime,
	imgHelp,
	productNameJC,
	appShow,
	bannerTime,
	bannerProductNameSplit,
	homeMsgTime,
	headImg,
	noticeFileType
}


// WEBPACK FOOTER //
// ./src/tools/filters.js